export { PrizmCallFuncModule } from './call-func.module';
export { PrizmCallFuncPipe } from './call-func.pipe';
